// Base URL for the Cry-Backend Express API (server.js, default PORT=5050).
// TODO: point this at your deployed backend URL in production
// (e.g. https://pantherp.in/cry-api or wherever Cry-Backend ends up hosted).
export const API_BASE_URL = '/api';

export async function handleResponse(res) {
  const data = await res.json().catch(() => ({}));
  if (!res.ok) {
    throw new Error(data.error || `Request failed with status ${res.status}`);
  }
  return data;
}